import * as React from "react";
import { GuestsType } from "../../model/utils";

const NumGuests = ({ numGuests }) => (
  <span>
    {numGuests[0] + numGuests[1]} ({numGuests[0]} adulti e {numGuests[1]}{" "}
    bambini)
  </span>
);

NumGuests.propTypes = {
  numGuests: GuestsType
};

export default NumGuests;
